import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { ISizeName } from '@df/core/service/client';
import { ImageModule } from '@df/module-image/image.module';
import { OffClickModule } from '@df/module-off-click/off-click.module';
import { RatingComponent } from '@df/ui/common/rating.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import orderBy from 'lodash-es/orderBy';
import { ISortOption, ProductReviewsComponent } from '../../product-reviews/product-reviews.component';
export enum SortReviewsOptions {
    recent = 'Recent',
    high = 'Highest rated',
    low = 'Lowest rated'
}
export const productReviewsModalId = 'product-reviews-modal';
@DfModal({
    id: productReviewsModalId,
    position: (sizeId: ISizeName) => (sizeId === 'S' || sizeId === 'M' ? 'bottom' : 'right'),
    config: sizeName => ({
        width: { S: '100vw', M: '100vw', L: '40rem', X: '40rem' }[sizeName],
        height: '100vh',
        position: {
            top: '0',
            right: '0',
            bottom: '0'
        },
        maxWidth: '100vw',
        modalClass: 'p-a-0'
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: sizeId => (['S', 'M'].includes(sizeId) ? ['S', 'M'] : ['L', 'X']),
    prerenderAllowed: false
})
@Component({
    selector: 'product-reviews-modal',
    templateUrl: './product-reviews-modal.html',
    styleUrls: ['product-reviews-modal.scss'],
    standalone: true,
    imports: [OffClickModule, TranslationModule, ImageModule, RatingComponent, SizeClassDirective, NgClass, ProductReviewsComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductReviewsModalComponent {
    protected sortOpen = false;
    protected sortOptions: ISortOption[] = [
        { name: SortReviewsOptions.recent, sortMethod: reviews => orderBy(reviews, model => model.data.date, ['desc']) },
        { name: SortReviewsOptions.high, sortMethod: reviews => orderBy(reviews, model => model.data.rating, ['desc']) },
        { name: SortReviewsOptions.low, sortMethod: reviews => orderBy(reviews, model => model.data.rating) }
    ];
    protected selectedSortOption: ISortOption = this.sortOptions[0];
    constructor(
        private modalRef: ModalRef<ProductReviewsModalComponent>,
        private changeDetectorRef: ChangeDetectorRef,
        @Inject(MODAL_DATA)
        public productsData: any
    ) {}
    close() {
        this.modalRef.close();
    }
    protected sortReviews(sortOption: ISortOption): void {
        this.selectedSortOption = sortOption;
        this.toggleSortOpen();
    }
    protected toggleSortOpen(state = false) {
        this.sortOpen = state;
        this.changeDetectorRef.detectChanges();
    }
}
